'use client';
import { usePlatformLink } from '@/blocks/components/PlatformLink';
import buttons from '@/styles/button.module.scss';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import React from 'react';

export function StrategyCta({ strategyId }: { strategyId: number }) {
  const { getStrategyLink } = usePlatformLink();
  const tr = useTranslations();
  return (
    <Link
      href={getStrategyLink(strategyId)}
      className={classNames(buttons.btn, buttons.btnPrimary, buttons.btnM)}
      data-event-label={tr.rich('en.pages.strategyPage.sections.hero.cta')}
    >
      {tr.rich('pages.strategyPage.sections.hero.cta')}
    </Link>
  );
}
